import {
  STORAGE_OVERVIEW_LIST,
  STORAGE_CLEAN_INPUT_LIST,
  STORAGE_CLEAN_INPUT_LIST_PAGE_COUNT,
  STORAGE_CLEAN_INPUT_LIST_TOTAL,
  STORAGE_CLEAN_INPUT_LIST_PAGE_SIZE,
  STORAGE_CLEAN_INPUT_BID,
  // STORAGE_CLEAN_INPUT_LAST_LOGIN_DAY,
  // STORAGE_CLEAN_INPUT_LAST_COMPLETE_DAY,
  // STORAGE_CLEAN_INPUT_LAST_PAY_DAY,
  // STORAGE_CLEAN_INPUT_MIN_SPACE,
  // STORAGE_CLEAN_INPUT_MIN_LAST_SUBMIT_DAY,
  STORAGE_CLEAN_INPUT_USER_ID,
} from './mutation-types'
import api from '@/api'

const state = {
  pageSize: 100,
  pageCount: 0,
  total: 0,
  list: [],
  inputList: [],
  bid: '',
  userId: '',
  // lastLoginDay: '',
  // lastCompleteDay: '',
  // lastPayDay: '',
  // minSpace: '',
  // lastSubmitDay: '',
}

const mutations = {
  [STORAGE_OVERVIEW_LIST](state, payload) {
    state.list = payload
  },
  [STORAGE_CLEAN_INPUT_LIST](state, payload) {
    state.inputList = payload
  },
  [STORAGE_CLEAN_INPUT_LIST_TOTAL](state, payload) {
    state.total = payload
  },
  [STORAGE_CLEAN_INPUT_LIST_PAGE_COUNT](state, payload) {
    state.pageCount = payload
  },
  [STORAGE_CLEAN_INPUT_BID](state, payload) {
    state.bid = payload
  },
  // [STORAGE_CLEAN_INPUT_LAST_LOGIN_DAY](state, payload) {
  //   state.lastLoginDay = payload
  // },
  // [STORAGE_CLEAN_INPUT_LAST_COMPLETE_DAY](state, payload) {
  //   state.lastCompleteDay = payload
  // },
  // [STORAGE_CLEAN_INPUT_LAST_PAY_DAY](state, payload) {
  //   state.lastPayDay = payload
  // },
  // [STORAGE_CLEAN_INPUT_MIN_SPACE](state, payload) {
  //   state.minSpace = payload
  // },
  // [STORAGE_CLEAN_INPUT_MIN_LAST_SUBMIT_DAY](state, payload) {
  //   state.lastSubmitDay = payload
  // },
  [STORAGE_CLEAN_INPUT_USER_ID](state, payload) {
    state.userId = payload
  },
}

const actions = {
  // 获取存储概览
  async getStorageStat({ commit }) {
    let data = await api.storageApi.getStorageStat({})
    let arrList = []
    let length = Object.keys(data.data).length
    if (data.code === 200 && length > 0) {
      for (let key in data.data) {
        let keyArr = key.split(' ')
        let item = {}
        item.platform = keyArr[0].split('-')[1]
        item.title = keyArr[1]
        item.items = data.data[key]
        // arrList.push(item)
        if (key.includes('input')) arrList[0] = item
        if (key.includes('output')) arrList[1] = item
        if (key.includes('temp')) arrList[2] = item
      }
    }
    // arrList.sort((a, b) => {
    //   return a.title.charCodeAt() > b.title.charCodeAt()
    // })
    commit(STORAGE_OVERVIEW_LIST, arrList)
  },
  async getUserInputStorageStatByBid({ state, commit }, payload) {
    let params = {
      bid: payload.bid,
      userId: payload.userId,
      lastLoginDay: payload.lastLoginDay,
      lastCompleteDay: payload.lastCompleteDay,
      lastPayDay: payload.lastPayDay,
      minSpace: payload.minSpace,
      pageSize: payload.pageSize,
      pageNum: payload.pageNum,
      lastSubmitDay: payload.lastSubmitDay,
    }
    try {
      let {
        data: { items, pageCount, total },
      } = await api.storageApi.getUserInputStorageStatByBid(params)
      commit(STORAGE_CLEAN_INPUT_LIST, items)
      commit(STORAGE_CLEAN_INPUT_LIST_PAGE_COUNT, pageCount)
      commit(STORAGE_CLEAN_INPUT_LIST_TOTAL, total)
      commit(STORAGE_CLEAN_INPUT_BID, payload.bid)
      commit(STORAGE_CLEAN_INPUT_USER_ID, payload.userId)
      // commit(STORAGE_CLEAN_INPUT_LAST_COMPLETE_DAY, payload.lastCompleteDay)
      // commit(STORAGE_CLEAN_INPUT_LAST_LOGIN_DAY, payload.lastLoginDay)
      // commit(STORAGE_CLEAN_INPUT_LAST_PAY_DAY, payload.lastPayDay)
      // commit(STORAGE_CLEAN_INPUT_MIN_LAST_SUBMIT_DAY, payload.lastSubmitDay)
      // commit(STORAGE_CLEAN_INPUT_MIN_SPACE, payload.minSpace)
    } catch (e) {
      commit(STORAGE_CLEAN_INPUT_LIST, [])
      commit(STORAGE_CLEAN_INPUT_LIST_PAGE_COUNT, 0)
    }
  },
  // 清理空间
  async cleanCustomerStore({ dispatch }, payload) {
    let data = await api.storageApi.cleanCustomerStore(payload)
    console.log('payload', payload)
    if (data.code === 200) {
      console.log('payload200', payload)
      if (payload.storeType === 'input') {
        dispatch('refreshStorageInputList')
      } else {
        dispatch('getStorageStat')
      }
    }
    return data
  },
  refreshStorageInputList({ dispatch }) {
    dispatch('getUserInputStorageStatByBid', {
      pageNum: 1,
      pageSize: state.pageSize,
      bid: state.bid,
      userId: state.userId,
      // lastCompleteDay: state.lastCompleteDay,
      // lastLoginDay: state.lastLoginDay,
      // lastPayDay: state.lastPayDay,
      // lastSubmitDay: state.lastSubmitDay,
      // minSpace: state.minSpace,
      type: 'refresh',
    })
  },
  updatePageSize({ commit }, payload) {
    commit(STORAGE_CLEAN_INPUT_LIST_PAGE_SIZE, payload)
  },
  // 过期清理
  async cleanUserStorageByExpireTime({ dispatch }, payload) {
    let data = await api.storageApi.cleanUserStorageByExpireTime(payload)
    if (data.code === 200) {
      if (payload.storeType === 'input') {
        dispatch('refreshStorageInputList')
      } else {
        dispatch('getStorageStat')
      }
    }
    return data
  },
  async getStorageStatByIp({ commit }, payload) {
    const { data } = await api.storageApi.queryStorageStat(payload)
    return data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
